var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './index.scss';
var SquareTextHero = function (_a) {
    var _b = _a.data, eyebrow = _b.eyebrow, headline = _b.headline;
    return (_jsxs("div", __assign({ className: "square-text-hero" }, { children: [_jsx("h6", __assign({ className: "square-text-hero_eye-brow" }, { children: eyebrow }), void 0),
            _jsx("p", __assign({ className: "square-text-hero_headline" }, { children: headline }), void 0)] }), void 0));
};
export default SquareTextHero;
